import { Facebook, Twitter, Mail } from "lucide-react";

export default function Footer() {
  const contacts = [
    {
      Icon: Facebook,
      label: "Station Facebook",
      href: "https://www.facebook.com/digitalrevolutionradio",
      testid: "contact-fb-station",
    },
    {
      Icon: Facebook,
      label: "Sondra (Owner)",
      href: "https://www.facebook.com/sondralupuliosego/",
      testid: "contact-fb-sondra",
    },
    {
      Icon: Twitter,
      label: "@drrradio on X",
      href: "https://x.com/drrradio",
      testid: "contact-x",
    },
    {
      Icon: Mail,
      label: "rocknrollstar12@gmail.com",
      href: "mailto:rocknrollstar12@gmail.com",
      testid: "contact-email",
    },
  ];

  return (
    <footer
      className="border-t border-zinc-800 bg-zinc-950 text-zinc-100"
      data-testid="site-footer"
    >
      <div className="grid grid-cols-12 border-b border-zinc-800">
        <div className="col-span-12 md:col-span-6 border-b md:border-b-0 md:border-r border-zinc-800 px-4 md:px-10 py-10 flex items-start gap-6">
          <a
            href="https://www.facebook.com/digitalrevolutionradio"
            target="_blank"
            rel="noopener noreferrer"
            className="shrink-0 group"
            data-testid="footer-logo-link"
            aria-label="Digital Revolution Radio on Facebook"
            title="Visit us on Facebook"
          >
            <img
              src="/drr-logo.png"
              alt="Digital Revolution Radio"
              className="w-24 h-24 md:w-32 md:h-32 object-contain border border-zinc-800 group-hover:border-red-600 bg-black transition-colors"
              data-testid="footer-logo"
            />
          </a>
          <div>
            <div className="font-display text-3xl md:text-4xl text-zinc-50 leading-none mb-3 glitch">
              DIGITAL <span className="text-red-600">REVOLUTION</span> RADIO
            </div>
            <p className="text-sm max-w-md leading-relaxed">
              Underground heavy metal & hard rock internet radio. Broadcasting
              24/7 because somebody has to.
            </p>
          </div>
        </div>
        <div className="col-span-6 md:col-span-3 border-r border-zinc-800 px-4 md:px-6 py-10">
          <div className="text-xs tracking-[0.3em] text-zinc-300 uppercase mb-4">
            //_TUNE
          </div>
          <ul className="space-y-2 text-sm">
            <li>
              <a href="/#listen" className="brutal-link">
                Live Player
              </a>
            </li>
            <li>
              <a href="/#chat" className="brutal-link">
                The Pit (Chat)
              </a>
            </li>
            <li>
              <a href="/schedule" className="brutal-link">
                Schedule
              </a>
            </li>
            <li>
              <a href="/djs" className="brutal-link">
                Meet the DJs
              </a>
            </li>
            <li>
              <a href="/#listen-anywhere" className="brutal-link">
                Listen Anywhere
              </a>
            </li>
            <li>
              <a
                href="https://www.thetoptens.com/internet/best-internet-radio-sites/"
                target="_blank"
                rel="noopener noreferrer"
                className="brutal-link inline-flex items-center gap-2"
                data-testid="footer-vote-link"
              >
                <span className="bg-yellow-400 text-black font-display text-[10px] tracking-widest px-1.5">#1</span>
                Vote For Us ↗
              </a>
            </li>
          </ul>
        </div>
        <div className="col-span-6 md:col-span-3 px-4 md:px-6 py-10">
          <div className="text-xs tracking-[0.3em] text-zinc-300 uppercase mb-4">
            //_CONTACT
          </div>
          <ul className="space-y-3 text-sm">
            {contacts.map(({ Icon, label, href, testid }) => (
              <li key={testid}>
                <a
                  href={href}
                  target={href.startsWith("mailto:") ? "_self" : "_blank"}
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 brutal-link"
                  data-testid={testid}
                >
                  <Icon className="w-4 h-4 text-red-500" strokeWidth={2} />
                  <span>{label}</span>
                </a>
              </li>
            ))}
            <li className="pt-1 text-xs text-zinc-600 tracking-widest uppercase">
              · or shout out in the pit
            </li>
          </ul>
        </div>
      </div>
      <div className="px-4 md:px-10 py-4 flex flex-wrap items-center justify-between gap-2 text-xs tracking-widest uppercase text-zinc-600">
        <span data-testid="footer-license">
          <span className="text-red-500">FULLY LICENSED</span> · ©{" "}
          {new Date().getFullYear()} DIGITAL REVOLUTION RADIO · ALL RIGHTS RESERVED
        </span>
        <span>BUILT LOUD. BUILT BRUTAL.</span>
      </div>
    </footer>
  );
}
